import CategoriseConfigController from './CategoriseConfig.controller.js'
import CategoriseConfigView from './CategoriseConfig.view.vue'

export default CategoriseConfigController(CategoriseConfigView)
